const map = {
  mapLoadFail: "地图加载失败"
} 
export default map